module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Trickle drops! my blue veins leaving!")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("O drops of me! trickle, slow drops,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Candid from me falling, drip, bleeding drops,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From wounds made to free you whence you were prison’d,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From my face, from my forehead and lips,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From my breast, from within where I was conceal’d, press forth red drops, confession drops,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stain every page, stain every song I sing, every word I say, bloody drops,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Let me know your scarlet heart, let them glisten,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saturate them with yourself all ashamed and wet,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Glow upon all I have written or shall write, bleeding drops,")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphText",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Let it all be seen in your light, blushing drops.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_vm._v("—Walt Whitman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leaves of Grass")])])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f34deab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312371111_epi.vue
// module id = 78
// module chunks = 0